export default __webpack_public_path__ + "static/media/(DownloadLagu321.Net) Gustixa Death Bed ft Shalom Margaret.0252d10e.mp3";